import * as types from "../actionTypes"

export const clearDragInteractions = () => ({
  type: types.END_DRAG,
  payload: {
    showDragUI: false,
  },
})
